module.exports = __webpack_public_path__ + "assets/img/marriage-title-icon.efe45ecf.png";